<template>
  <div @click="prompt()">
    <slot>
      <button
        type="button"
        class="delete"
      />
    </slot>
  </div>
</template>

<script>
export default {
  methods: {
    prompt() {
      this.$buefy.dialog.confirm({
        title: this.$t("remove_record"),
        message: this.$t("confirm_remove"),
        confirmText: this.$t("remove_record"),
        cancelText: this.$t("cancel"),
        type: "is-warning",
        onConfirm: () => this.$emit("click")
      });
    },
  }
};
</script>
